import { render, staticRenderFns } from "./NavigationHeader.vue?vue&type=template&id=f510539e"
import script from "./NavigationHeader.vue?vue&type=script&lang=js"
export * from "./NavigationHeader.vue?vue&type=script&lang=js"
import style0 from "./NavigationHeader.vue?vue&type=style&index=0&id=f510539e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports